import { render, staticRenderFns } from "./delete-confirm.vue?vue&type=template&id=b2f51a40&"
import script from "./delete-confirm.vue?vue&type=script&lang=js&"
export * from "./delete-confirm.vue?vue&type=script&lang=js&"
import style0 from "./delete-confirm.vue?vue&type=style&index=0&id=b2f51a40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports